import React from 'react';
import MachineDataDownloadMenuItem from '../machinedata/MachineDataDownloadMenuItem';

function FileSection(props) {
	const { isMachineDetailPage } = props;
	return (
		<React.Fragment>
			{isMachineDetailPage ? <MachineDataDownloadMenuItem /> : null}
		</React.Fragment>
	);
}
export default FileSection;



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/MainDrawerExtensions/FileSection.js